import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalVars, cookieGlobalVars } from 'src/app/general/variables';
// import * as CryptoJS from 'crypto-js';
// import {CookieService} from 'ngx-cookie-service';
import { CabeceraPpFwComponent } from '../../formulario-web/cabecera-pp-fw/cabecera-pp-fw.component';
import { ContenedorAsigInfoComponent } from '../contenedor-asig-info/contenedor-asig-info.component';

@Component({
  selector: 'app-panel-principal',
  templateUrl: './panel-principal.component.html',
  styleUrls: ['./panel-principal.component.css']
})
export class PanelPrincipalComponent implements OnInit {

  mostrarOri = false;
  mostrarSeg = true;
  usuario: string;
  flagMenu = true;

  @ViewChild(CabeceraPpFwComponent) cabeceraPpFwC: CabeceraPpFwComponent;
  @ViewChild(ContenedorAsigInfoComponent) contenedorAsigInfoC: ContenedorAsigInfoComponent;


  constructor(
    // private route: ActivatedRoute,
    public router: Router,
    // private cookieService: CookieService
    ) { }

  ngOnInit() {

    let vUsuario: string = null;


    // cookieGlobalVars(2,this.cookieService);

    cookieGlobalVars(2);

    vUsuario = GlobalVars.DscNombreComplPers;

    this.usuario = vUsuario;

    this.cabeceraPpFwC.setUsuario(vUsuario);
    this.cabeceraPpFwC.setFlgLogin(true);

    // console.log("==========Globalvars");
    // console.log(GlobalVars.CodUsuario);

    // console.log(this.usuario);

    // this.route.queryParams
    //   .subscribe(params => {
    //     // Defaults to 0 if no query param provided.

    //     this.usuario = params['usuario'];

    //     console.log("=================this.usuario");

    //     console.log(this.usuario);

    //     console.log(params);
    //   });

  }

  _mostrarNewRegistro(numCaso: number) {

    this.contenedorAsigInfoC.initFlagPanelPrincipal(true);

    const vFlgNewReg: boolean = (numCaso == 1 || numCaso == 3);

    setTimeout(() => {

      this.contenedorAsigInfoC.OpcionSeleccionada(numCaso);

      if (vFlgNewReg) {

        setTimeout(() => {

          this.contenedorAsigInfoC.NuevoSeleccionado(0);

        }, 1);

      }

    }, 1);


    this._abrirMenuOut();

  }

  _abrirMenuOut() {

    if (this.flagMenu) {
      document.getElementById('mySidenav').style.width = '250px';
      this.flagMenu = false;
    } else {
      document.getElementById('mySidenav').style.width = '0px';
      this.flagMenu = true;
    }

  }

  MostrarOrientacion() {

    this.mostrarOri = true;

  }

  MostrarSeguimiento() {

    this.mostrarSeg = true;

    // this.router.navigate(['/BodyOpciones/']);

  }

  EvaluarInformacion() {

  }

  // openNav() {
  //   if(this.flagMenu){
  //    document.getElementById("mySidenav").style.width = "250px";
  //    this.flagMenu = false;
  //  }else{
  //    document.getElementById("mySidenav").style.width = "0px";
  //    this.flagMenu = true;
  //  }

  //  //document.getElementById("main").style.marginLeft = "350px";
  //  }

}
